<template>
  <article class="t-left pcinner">
    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
    <div class="entry-content">
      <h1>閲覧したアイテム</h1>
      <ItemList v-bind:ItemList="itemList" v-bind:ItemTotal="itemTotal" />
    </div>
  </article>
</template>

<script>
import axios from 'axios'
import ItemList from '@/components/ItemList.vue'
import Paginate from 'vuejs-paginate';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


export default {
  components: {
    ItemList,
    Paginate,
    Loading
  },
  data () {
    return {
      itemList: [],
      itemTotal: 0,
      isLoading: false,
      fullPage: false,
      viewed: []
    }
  },
  created () {
    this.initialize()
    this.setupPage(this.$route)
  },
  watch: {
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize()
    this.setupPage(to)
    next();
  },
  methods: {
    initialize() {
      this.refresh();
    },
    refresh() {
      this.itemList = {}
      this.itemTotal = 0
      this.itemPageTotal = 0
      this.itemPage = 1
      this.isLoading = false
    },
    setupPage(route) {
      // header
      let title = '閲覧アイテム'
      let description = '閲覧アイテムページ。sports style内で閲覧したアイテムを確認することができます。'
      this.setHeader(title, description, true)

      let viewed = JSON.parse(localStorage.getItem('viewed'));
      if(viewed != null){
        if(viewed.length > 0){
          // Loading
          this.isLoading = true

          if(route.query.page){
              this.itemPage = parseInt(route.query.page)
          }
          axios.get('https://app3.sportsstyle.net/items/ids/?ids=' + viewed.join())
          .then((res) => {
            this.itemList = res.data.list
            this.itemTotal = res.data.item_total
            this.isLoading = false
          })
          .catch(() =>{
            console.log('item list not found')
           // this.$router.push({ name: "404"})
          })
        }
      }
    },
    clickCallback(pageNum) {
      this.$router.push({ name: "itemList", query:{page: pageNum}})
    }
  }
}
</script>
